<!-- eslint-disable max-len -->
<template>
	<div class="breakout">
		<CircleColorBtn
			:image="image"
			:label="title"
			:icon-tooltip="'Switch color'"
			@btn:click="openFlyout"
		>
			<template #icon>
				<svg width="90" height="100" version="1.1" viewBox="0 0 90 100" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
					<g transform="matrix(.18784 0 0 .18385 4.0235 4.9999)"><path d="m241.56 488.16c98.2-11 176.9-89.5 188.1-187.7 14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9l-118.6 87.1c-2 1.5-2 4.4 0 5.9l118.6 87.1c2.7 2 6.7 0.2 6.7-2.9v-57.5c87.9 1.4 158.3 76.2 152.3 165.6-5.1 76.9-67.8 139.3-144.7 144.2-81.5 5.2-150.8-53-163.2-130-2.3-14.3-14.8-24.7-29.2-24.7-17.9 0-31.9 15.9-29.1 33.6 17.4 109.7 118.7 192 236 178.9z" fill="#fff"/></g>
				</svg>
			</template>
		</CircleColorBtn>


		<div class="breakout__percentage">
			<button
				class="breakout__percentage__btn breakout__percentage__btn--decrease"
				type="button"
				:disabled="disableBtnDecrease"
				@click="$emit( 'update:percentage', id, percentage - 1 )"
			>
				-
			</button>

			<div class="breakout__percentage__value">
				<input
					class="breakout__percentage__value__input"
					:value="percentage"
					type="number"
					@input="$emit( 'update:percentage', id, parseInt( $event.target.value, 10 ) )"
				>
				<span class="breakout__percentage__value__symbol">%</span>
			</div>

			<button
				class="breakout__percentage__btn breakout__percentage__btn--increase"
				type="button"
				:disabled="disableBtnIncrease"
				@click="$emit( 'update:percentage', id, percentage + 1 )"
			>
				+
			</button>
		</div>


		<!-- <div class="breakout__percentage">
			<div
				ref="nodePercentageSlider"
				class="breakout__percentage__slider"
			/>
		</div> -->

		<button
			v-if="canTrash"
			ref="nodeIconTrash"
			class="breakout__trash"
			type="button"
			@click="emit( 'trash', id )"
		>
			<svg class="breakout__trash__icon" width="20" height="24" version="1.1" viewBox="0 0 5.2917 6.35" xmlns="http://www.w3.org/2000/svg">
				<g transform="matrix(.010583 0 0 .011369 -.0635 .26458)"><path d="m436 60h-75v-15c0-24.813-20.187-45-45-45h-120c-24.813 0-45 20.187-45 45v15h-75c-24.813 0-45 20.187-45 45 0 19.928 13.025 36.861 31.005 42.761l26.755 322.98c1.927 23.139 21.625 41.264 44.844 41.264h244.79c23.22 0 42.918-18.125 44.846-41.271l26.753-322.97c17.98-5.899 31.005-22.832 31.005-42.76 0-24.813-20.187-45-45-45zm-255-15c0-8.271 6.729-15 15-15h120c8.271 0 15 6.729 15 15v15h-150zm212.34 423.25c-0.643 7.712-7.208 13.754-14.948 13.754h-244.79c-7.739 0-14.305-6.042-14.946-13.747l-26.364-318.25h327.41zm42.656-348.25h-360c-8.271 0-15-6.729-15-15s6.729-15 15-15h360c8.271 0 15 6.729 15 15s-6.729 15-15 15z"/><path d="m195.97 436.07-15-242c-0.513-8.269-7.67-14.558-15.899-14.043-8.269 0.513-14.556 7.631-14.044 15.899l15 242c0.493 7.953 7.097 14.072 14.957 14.072 8.687 0 15.519-7.316 14.986-15.929z"/><path d="m256 180c-8.284 0-15 6.716-15 15v242c0 8.284 6.716 15 15 15s15-6.716 15-15v-242c0-8.284-6.716-15-15-15z"/><path d="m346.93 180.03c-8.25-0.513-15.387 5.774-15.899 14.043l-15 242c-0.511 8.268 5.776 15.386 14.044 15.899 8.273 0.512 15.387-5.778 15.899-14.043l15-242c0.512-8.269-5.775-15.387-14.044-15.899z"/></g>
			</svg>
		</button>
	</div>

	<ColorFlyout
		v-if="showFlyout"
		:color-data="selectableColors"
		:text="flyoutInstructions"
		@select:color="handleSelectColor"
		@close:flyout="closeFlyout"
	/>
</template>


<style lang="scss">
// @import 'npm:nouislider/dist/nouislider.min.css';
@import 'npm:tippy.js/dist/tippy.css';

.breakout {
	$transitionSpeed: 0.125s;

	position: relative;
	flex-basis: 50%;
	display: flex;
	flex-direction: column;
	place-items: center;
	margin-bottom: 24px;
	// padding-bottom: 46px;

	@media( max-width: 1023px ) {
		padding-top: 44px;
	}

	@media( min-width: 1024px ) {
		margin-bottom: 32px;
	}

	&__percentage {
		display: flex;
		width: 100%;
		margin-top: auto;
		place-content: center;
		place-items: center;

		@media( max-width: 600px ) {
			flex-wrap: wrap;
		}

		// todo -- way to combine below with above?
		@media( min-width: 1024px ) and ( max-width: 1199px ) {
			flex-wrap: wrap;
		}

		&__value {
			position: relative;
			display: flex;
			place-items: center;
			place-content: center;
			margin-left: 6px;
			margin-right: 6px;

			@media( max-width: 600px ) {
				order: 1;
				width: 100%;
				margin: 6px 0;
			}

			&__input {
				width: 100%;
				max-width: 220px;
				padding: 12px 32px 12px 24px;
				font-size: 20px;
				text-align: center;
				border: 1px solid #b8b8b8 !important;
				border-radius: 50px !important;
				background-color: white !important;
				color: #2D2A26;

				&::-webkit-outer-spin-button,
				&::-webkit-inner-spin-button {
					-webkit-appearance: none;
				}

				@media( max-width: 600px ) {
					max-width: unset;
				}
			}

			&__symbol {
				position: absolute;
				right: 12px;
				display: block;
				margin-left: 4px;
				font-size: 18px;
				color: #b8b8b8;
			}
		}

		&__btn {
			display: flex;
			place-items: center;
			place-content: center;
			width: 40px;
			height: 40px;
			aspect-ratio: 1;
			color: white;
			background-color: var( --solid-blue );
			border: none;
			border-radius: 50%;

			&[disabled] {
				background-color: #b8b8b8;
				cursor: not-allowed;
			}

			@media( max-width: 600px ) {
				&--decrease {
					order: 2;
					margin-right: auto;
				}

				&--increase {
					order: 3;
					margin-left: auto;
				}
			}

			// todo -- way to combine below with above?
			@media( min-width: 1024px ) and ( max-width: 1199px ) {
				margin-top: 6px;

				&--decrease {
					order: 2;
					margin-right: auto;
				}

				&--increase {
					order: 3;
					margin-left: auto;
				}
			}
		}

		// &__slider {
		// 	background-color: #efefef;
		// 	border-radius: 36px;
		// 	box-shadow: none;
		// 	border: 1px solid #d0d0d0;

		// 	.noUi {
		// 		&-handle {
		// 			width: 28px;
		// 			height: 28px;
		// 			background-color: #0093c9;
		// 			border-radius: 50%;
		// 			border: 2px solid white;
		// 			box-shadow: 0 0 4px 2px rgba( 0,0,0,0.1);

		// 			&:before,
		// 			&:after {
		// 				content: initial;
		// 			}
		// 		}

		// 		&-connect {
		// 			background-color: transparent;
		// 		}

		// 		&-tooltip {
		// 			top: 120%;
		// 			bottom: initial;
		// 			border: initial;
		// 		}
		// 	}
		// }
	}

	&__trash {
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		width: 44px;
		height: 44px;
		padding: 0;
		border: none;
		background: none;
		place-items: center;
		place-content: center;
		z-index: 1000;
		opacity: 0.7;
		transition: $transitionSpeed linear;

		@media( min-width: 1024px ) {
			// top: -22px;
			right: -30px;
		}

		&:hover {
			opacity: 1;
		}

		&__icon {
			display: block;
			width: 24px;
			height: auto;
		}
	}
}

// todo - switch to Tippy template
.tippy {
	&-box {
		color: white;
		background-color: #CF3339;
	}

	&-arrow {
		color: #CF3339;
	}
}

</style>


<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
// import noUiSlider from 'nouislider'
// import wNumb from 'wnumb'
import CircleColorBtn from './CircleColorBtn.vue'
import ColorFlyout from './ColorFlyout.vue'


const props = defineProps({
	id: {
		type: Number,
		required: true,
	},
	index: {
		type: Number,
		required: true,
	},
	title: {
		type: String,
		required: true,
	},
	image: {
		type: String,
		required: true,
	},
	percentage: {
		type: Number,
		required: true,
	},
	selectableColors: {
		type: Array,
		required: true,
	},
	flyoutInstructions: {
		type: String,
		default: '',
	},
	canTrash: {
		type: Boolean,
		default: true,
	},
	freezeSlider: {
		type: Boolean,
		default: false,
	},
	steps: {
		type: Number,
		default: 1,
	},
})


const emit = defineEmits(
	[
		'update:percentage',
		'change:color',
		'trash',
	],
)


const showFlyout = ref( false )

const nodePercentageSlider = ref( null ) // to be populated by HTML element representing slider (see template)
const nodeIconTrash = ref( null )

let noUiSliderInstance = null
let btnTrashTippy = null


/**
 * Open flyout for color selection
 *
 * @return {void}
 */
const openFlyout = () => {
	showFlyout.value = true
}


/**
 * Close flyout
 *
 * @return {void}
 */
const closeFlyout = () => {
	showFlyout.value = false
}


/**
 * Handle user selecting color from flyout
 *
 * @param {number}
 * @return {void}
 */
const handleSelectColor = colorId => {
	emit( 'change:color', colorId, props.index, props.percentage, props.id )

	closeFlyout()
}


// eslint-disable-next-line arrow-body-style
const disableBtnDecrease = computed( () => {
	return 0 >= props.percentage
})


// eslint-disable-next-line arrow-body-style
const disableBtnIncrease = computed( () => {
	return 100 <= props.percentage
})


// if percentage from parent changes, then let's make sure UI slider is updated
// watch( () => props.percentage, newPercentageValue => {
// 	if ( noUiSliderInstance && newPercentageValue !== noUiSliderInstance.get() ) {
// 		noUiSliderInstance.set( newPercentageValue )

// 		if ( props.freezeSlider ) {
// 			noUiSliderInstance.disable()
// 		} else {
// 			noUiSliderInstance.enable()
// 		}
// 	}
// })


onMounted( () => {
	if ( props.canTrash ) {
		import( 'tippy.js' ).then( tippy => {
			btnTrashTippy = tippy.default( nodeIconTrash.value, {
				content: 'Remove color',
				placement: 'top',
			})
		})
	}

	// noUiSliderInstance = noUiSlider.create( nodePercentageSlider.value, {
	// 	start: props.percentage,
	// 	connect: 'lower',
	// 	tooltips: [
	// 		wNumb({
	// 			decimals: 0,
	// 			suffix: '%',
	// 		}),
	// 	],
	// 	step: 1,
	// 	range: {
	// 		min: 0,
	// 		max: 100,
	// 	},
	// })

	// noUiSliderInstance.on( 'change', values => {
	// 	const percentage = parseInt( values[0], 10 )

	// 	if ( !Number.isNaN( percentage ) ) {
	// 		emit( 'update:percentage', props.id, percentage )
	// 	}
	// })
})


onUnmounted( () => {
	if ( btnTrashTippy ) {
		btnTrashTippy.destroy()
	}
})


// onBeforeUpdate( () => {
// 	noUiSliderInstance.updateOptions({
// 		step: props.steps,
// 	}, true )
// })

</script>
